const getPaymentAccountNumber = (state: any) =>
  state.getIn(['paymentSettings', 'data', 'accountNumber']);

export default getPaymentAccountNumber;
